/**
 * useMessaging — React hook for resolved copy.
 *
 * Usage:
 *   const headline = useMessaging('hero.headline_main');
 *   const headline = useMessaging('hero.headline_main', 'Fallback Title');
 *
 * Re-renders the calling component when the override cache changes (e.g.
 * after the network fetch completes or a super-admin saves a change in
 * the messaging admin UI).
 */
import { useEffect, useState } from 'react';
import { getMessage, subscribeMessaging } from '../lib/messagingClient';

export function useMessaging(path, fallback = '') {
  const [value, setValue] = useState(() => getMessage(path, fallback));

  useEffect(() => {
    // Re-resolve in case the override fetch landed between initial state
    // computation and effect run.
    setValue(getMessage(path, fallback));
    return subscribeMessaging(() => setValue(getMessage(path, fallback)));
  }, [path, fallback]);

  return value;
}

export default useMessaging;
